/* Sadly we cannot just use 'react-native-url-polyfill' because it breaks on web in
 node_modules/whatwg-url-without-unicode/lib/url-state-machine.js:541
 on punycode.ucs2 being undefined when bundled by webpack. So we use browser-provided URL which
 should work normally in web environment.
*/
const SafeURL = URL;
export { SafeURL };
